import { render, staticRenderFns } from "./FieldBase.vue?vue&type=template&id=6cfd82d4&scoped=true&"
import script from "./FieldBase.vue?vue&type=script&lang=js&"
export * from "./FieldBase.vue?vue&type=script&lang=js&"
import style0 from "./style.styl?vue&type=style&index=0&id=6cfd82d4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd82d4",
  null
  
)

export default component.exports